import Vue from 'vue'
import Router from 'vue-router'
import Book from '@/components/Book.vue'
import Practice from '@/components/subComponents/practice.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'book',
            component: Book
        }, {
            path: "/practice",
            name: "practice",
            component: Practice
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js